module.exports = __webpack_public_path__ + "img/zhinengjiaju3.36fd2040.jpg";